import React, {useEffect} from 'react';
import * as Yup from 'yup';
import {Field, Form, Formik} from "formik";
import {Input, Select} from "../../../../../../_metronic/_partials/controls";

import {fetchAllBranches} from '../../../../Base/_redux/branches/branchesActions';
import {shallowEqual, useDispatch, useSelector} from "react-redux";


const InvoiceCreateSchema = Yup.object().shape({
    branchId: Yup.string().required('لطفا شعبه مورد نظر را انتخاب کنید'),
    description: Yup.string()
})

const initialValues = {
    branchId: "",
    description: ""
}

export function InvoiceCreateForm({
                                      btnRef,
                                      createInvoice
                                  }) {

    const {branches, branchesLoading} = useSelector((state) => {
        return {
            branches: state.branches.entities,
            branchesLoading: state.branches.listLoading
        }
    }, shallowEqual);

    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(fetchAllBranches());
    }, [dispatch]);


    return (
        <>
            <Formik initialValues={initialValues} onSubmit={(values) => createInvoice(values)}
                    validationSchema={InvoiceCreateSchema}
                    enableReinitialize={true}
            >
                {({handleSubmit}) => (
                    <>

                        <Form className={"form form-label-right"}>
                            <div className={"form-group row px-4"}>
                                <div className={"col-lg-6 mb-1"}>
                                    <Select
                                        name={"branchId"}
                                        label={"شعبه"}
                                        withFeedbackLabel
                                    >
                                        <option value={""}>لطفا یک شعبه را انتخاب کنید</option>
                                        {branches && branches.map(branch => (
                                            <option key={branch.id} value={branch.id}>
                                                {branch.name}
                                            </option>
                                        ))}
                                    </Select>
                                </div>
                                <div className={"col-lg-12"}>
                                    <Field
                                        name={"description"}
                                        component={Input}
                                        placeholder={"توضیحات فاکتور"}
                                        label={"توضیحات"}
                                    />
                                </div>
                            </div>

                            <button
                                type={"submit"}
                                style={{display: "none"}}
                                ref={btnRef}
                                onSubmit={() => handleSubmit()}
                            />
                            
                        </Form>

                    </>
                )}
            </Formik>
        </>
    )
}